export enum LinkType {
  QUIET = 'quiet',
  UNDERLINE = 'underline',
  BUTTON = 'button',
}

export enum LinkColor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  NEGATIVE = 'negative',
  DARK = 'dark',
  LIGHT = 'light',
}

export enum Target {
  BLANK = '_blank',
  SELF = '_self',
  PARENT = '_parent',
  TOP = '_top',
}

export enum ButtonFill {
  OUTLINE = 'outline',
}
